import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

import Icon from '../../Icon/Icon'

function MessageFile({
  file,
  iconName = 'download',
  removeFile = null,
}) {
  function clickHandler(e) {
    e.preventDefault()
    removeFile(file.attributes.fileName)
    return true
  }

  const fileAttachment = (
    <Fragment>
      <div className="message-attachment__icon-container message-attachment__icon-container--big">
        <Icon type={['fal', 'file-archive']} className="message-attachment__icon" />
      </div>
      <div className="message-attachment__body">
        <p className="message-attachment__filename">{file.attributes.fileName}</p>
        <p className="message-attachment__filesize">Size {numeral(file.attributes.fileSize).format('0.0b')}</p>
      </div>
      <div className="message-attachment__icon-container message-attachment__icon-container--small">
        <Icon type={['fas', iconName]} className="message-attachment__icon" />
      </div>
    </Fragment>
  )

  return (
    file.attributes.url
      ? (
        <a
          href={file.attributes.url}
          download={file.attributes.fileName}
          className="message-attachment message-attachment--aligned"
          onClick={(e) => { removeFile && clickHandler(e) }}
        >
          {fileAttachment}
        </a>
      )
      : (
        <div
          className="message-attachment message-attachment--aligned"
          onClick={(e) => { removeFile && clickHandler(e) }}
        >
          {fileAttachment}
        </div>
      )
  )
}

MessageFile.propTypes = {
  file: PropTypes.shape({
    attributes: PropTypes.shape({
      fileName: PropTypes.string.isRequired,
      fileSize: PropTypes.number.isRequired,
      url: PropTypes.string,
    }).isRequired,
  }).isRequired,
  iconName: PropTypes.string,
  removeFile: PropTypes.func,
}

export default MessageFile
